<template>
    <div class="basket-page-list-item">
        <div class="basket-page-list-item-details" v-for="(item, index) in listItems" :key="index">
            <div class="row py-3" :class="[(listItems.length > index + 1 ? 'border-bottom' : '')]">
                <div :class="['basket-page-tile-image py-3 col-xl-2 col-md-6 col-sm-4 basket-page-tile-image-mobile-device', (item.InventoryType == 'paint' ? 'tile-paint' : '')]">
                    <div v-if="item.ProductTypeDesc && !item.IsTrayItem && !item.IsIdeaBook && item.InventoryType !== 'paint'">
                        <a class="cart-item-model-no" target="_blank" :href="$helpers.getProductDetailUrl(
                            item.StyleNameURL,
                            item.SellingStyleNumber,
                            item.SellingColorNumber
                        )
                            ">
                            <img :src="(item.ImageUrl || '')" class="pc-tile-product-img" alt="" @error="handleImageError" />
                        </a>
                    </div>
                    <div v-else>
                        <div v-if="item.InventoryType === 'paint'">
                            <div class="pc-tile-product-img" :style="{ backgroundColor: item.PaintHex ? '#' + item.PaintHex : '000' }"></div>
                        </div>
                        <div v-else>
                            <img :src="(item.ImageUrl || '')" class="pc-tile-product-img" alt="patcraft" @error="handleImageError" />
                        </div>
                    </div>
                </div>

                <div class="item-details py-3 col-xl-3 col-md-6 col-sm-8 basket-page-item-details-mobile-device">
                    <div class="pb-md-2">
                        <div v-if=" item.ProductTypeDesc && !item.IsTrayItem && !item.IsIdeaBook && item.InventoryType !== 'paint'" class="list-item-label-row">
                            <span>{{ $resourceString["myBasket.ProductList.Label.Style"] }}:</span>
                            <a target="_blank" class="text-decoration-underline cart-item-model-no text-uppercase font-weight-bold font-size-item-label" :href="$helpers.getProductDetailUrl(
                                    item.StyleNameURL,
                                    item.SellingStyleNumber,
                                    item.SellingColorNumber
                                )">
                                <div>
                                    {{ item.SellingStyleName }}
                                    {{ item.SellingStyleNumber }}
                                </div>
                            </a>
                        </div>
                        <div v-else>
                            <div class="list-item-label-row">
                                <span>{{ $resourceString["myBasket.ProductList.Label.Style"] }}:</span>
                                <div class="text-uppercase font-weight-bold font-size-item-label">
                                    {{ item.SellingStyleName }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pb-md-2">
                        <div class="list-item-label-row">
                            <span>{{ $resourceString["myBasket.ProductList.Label.Color"] }}:</span>
                            <div class="font-weight-light cart-item-color-no">
                                {{ item.SellingColorNumber }}
                            </div>
                        </div>
                    </div>
                    <div class="pb-md-2">
                        <div class="list-item-label-row">
                            <span>{{ $resourceString["myBasket.ProductList.Label.Collection"] }}:</span>
                            <div>
                                {{ item.Collection }}
                            </div>
                        </div>
                    </div>
                    <div class="pb-md-2">
                        <div class="list-item-label-row">
                            <span>{{ $resourceString["myBasket.ProductList.Label.Product"] }}:</span>
                            <div>
                                {{ item.ProductTypeDesc ? item.ProductTypeDesc : "Other" }}
                            </div>
                        </div>
                    </div>
                    <div class="pb-md-2">
                        <div class="list-item-label-row">
                            <span>{{ $resourceString["myBasket.ProductList.Label.Category"] }}:</span>
                            <div>
                                {{ item.InventoryType }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-4 col-md-6 col-12 py-3 size-quantity-col">
                    <div class="list-item-label-row pb-2 sample-size-box" v-if="item.SampleSizes !== null && !item.IsIdeaBook">
                        <span>{{ $resourceString["myBasket.ProductList.Label.SampleSize"] }}:</span>
                        <div v-if="item.SelectedSample">
                            {{ item.SelectedSample.Text }}
                        </div> 
                        <div v-else>
                            N/A
                        </div>
                    </div>

                    <div class="pb-2">
                        <div class="list-item-label-row sample-size-box">
                            <span>{{ $resourceString["myBasket.ProductList.Label.Quantity"] }}:</span>
                            <div class="font-weight-light cart-item-color-no">
                                {{ item.Quantity }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- remove and add to button -->
                <div class="col-xl-3 col-md-6 col-12 py-3 text-uppercase remove-saveforlater-col">
                    <a class="remove-btn font-size-item-label" href="#remove" @click.prevent="saveRemove(item)">
                        {{ $resourceString["myBasket.Button.Remove"] }}
                        <span class="png-icon png-icon-icons-glyph--g-close-sqr-fill"></span>
                    </a>
                    <div class="addtobasket-btn">
                        <wf-add-to-cart-button-only
                            :selling-style-number="item.SellingStyleNumber"
                            :color-number="item.SellingColorNumber"
                            :vehicle-id="item.VehicleId"
                            :quantity="item.Quantity"
                            :save-for-later="true"
                            :inventory-style-number="item.InventoryStyleNumber"
                            :button-text="$resourceString['myBasket.Button.AddToBasket']"
                            :list-name="listName"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import WfAddToCartButtonOnly from "../wf-add-to-cart-button-only.vue";
import { globalIcons } from "../../../constants/global";
export default {
    props: {
        listItems: {
          required: true
        },
        listName: {
          required: true
        },
    },
    data() {
        return{
            defaultImage:globalIcons.defaultImage
        }
    },
    components: {
        WfAddToCartButtonOnly,
    },
    methods: {
        ...mapActions({
           fetchSaveForLaterItems: "newBasketPage/fetchSaveForLaterItems"
        }),
        saveRemove(item) {
            let payload = {
                InventoryStyleNumber: item.InventoryStyleNumber,
                SellingStyleNumber: item.SellingStyleNumber,
                vehicleId: item.VehicleId,
                colorNumber: item.SellingColorNumber,
                RequestAction: "remove"
            };
            this.fetchSaveForLaterItems(payload);
        },
        handleImageError(event) {
          event.target.src = this.defaultImage;
        },
    },

}
</script>